<app-loader *ngIf="isDisabled"></app-loader>
<div class="main-container mt-5">
    <form class="g-3" name="MailApprovalForm" (ngSubmit)="Validate(MailApprovalForm)" #MailApprovalForm="ngForm"
        novalidate>
        <div class="card">
            <div style="text-align: center" class="mb-1" *ngIf="LogoPath != null && LogoPath != ''">
                <img src="{{LogoPath}}" width="160px" class="logo">
            </div>
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <span>SPOC Approval</span>
                </div>
            </div>
            <div class="remark-section" *ngIf="IsAllow">
                <h6 class="mb-3" style="color: var(--primary);">
                    <i class="bi bi-chat-text me-2"></i>Add Your Remarks
                </h6>
                <div class="mb-3">
                    <label for="remarks" class="form-label">Remarks<span class="mandatory-field">*</span></label>
                    <textarea type="text" class="form-control" rows="3"
                        placeholder="Enter your comments or remarks here..." id="remarks" name="remarks"
                        [(ngModel)]="remark" #remarks="ngModel" maxlength="200" required></textarea>

                    <div class="invalid-feedback" *ngIf="!IsAllow">
                        Please enter remark!
                    </div>
                </div>
            </div>

            <div class="detail-label text-success" style="font-size: larger; margin: 3rem; align-self: anchor-center;" *ngIf="!IsAllow">{{Message}}</div>

            <!-- Action Buttons -->
            <div class="action-buttons">
                <button type="button" class="btn btn-outline-secondary" (click)="this.closeTab()">
                    <i class="bi bi-arrow-left me-1"></i> Back
                </button>
                <button class="btn btn-danger" *ngIf="this.common.ToLowerCase(status) == 'rejected' && IsAllow">
                    <i class="bi bi-x-circle me-1"></i> Reject
                </button>
                <button class="btn btn-success" *ngIf="this.common.ToLowerCase(status) == 'approved' && IsAllow">
                    <i class="bi bi-check-circle me-1"></i> Approve
                </button>
            </div>


        </div>
    </form>
</div>